<template>
  <v-app id="app">

    <v-navigation-drawer v-if="!isSpecialRoute()" v-model="doShowNavigationDrawer" app clipped color="accent">
      <v-list>
        <v-list-item
          v-for="navigationItem in getNavigationItems()"
          :key="navigationItem.title"
          @click="$router.push({path: navigationItem.route}).catch(() => {})"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ navigationItem.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>{{ navigationItem.title }}</v-list-item-content>
        </v-list-item>
        
        <v-divider></v-divider>
        <v-list-item v-if="!isLoggedInMSAL()" @click="$router.push({path: '/login'}).catch(() => {})">
          <v-list-item-icon >
            <v-icon>mdi-login</v-icon>
          </v-list-item-icon>
          <v-list-item-content>{{ $t("views.app.navigation.login") }}</v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isLoggedInMSAL()" @click="logoutMSAL()">
          <v-list-item-icon >
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>{{ $t("views.app.navigation.logout") }}</v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item href="https://www.leeb-balkone.com/">
          <v-list-item-icon >
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>Leeb-Homepage</v-list-item-content>
        </v-list-item>
      </v-list>
      
      <template v-slot:append>
        <div class="pa-2" v-show="false">
          <LanguageChooser></LanguageChooser>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- Must have the app property -->
    <v-app-bar
      v-if="!isSpecialRoute()"
      app
      color="white"
      light
      clipped-left
    >
      <!-- Navigation drawer buttons -->
      <v-app-bar-nav-icon v-if="doShowNavigationDrawer" @click.stop="toggleShowNavigationDrawer()">
        <v-icon>mdi-close</v-icon>
      </v-app-bar-nav-icon>
      <v-app-bar-nav-icon v-if="!doShowNavigationDrawer" @click.stop="toggleShowNavigationDrawer()">
      </v-app-bar-nav-icon>

      <!-- Logo as title -->
      <v-toolbar-title>
        <v-img :src="require('@/assets/logo/leeb-logo.svg')" :width="160" :height="45" contain></v-img>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Options for the right side -->
      <v-toolbar-items class="hidden-sm-and-down" v-show="false">
        <v-divider vertical></v-divider>
        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-divider vertical></v-divider>
        <v-menu
          left
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="n in 5"
              :key="n"
              @click="() => {}"
            >
              <v-list-item-title>Option {{ n }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-divider vertical></v-divider>
      </v-toolbar-items>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <!-- Snackbar messages are displayed to right -->
    <v-snackbar-queue :timeout="5000" :pause="500" top right app>
      <template slot="default" slot-scope="props">
        <v-icon small :color="(props.snackbar && props.snackbar.color)" v-if="(props.snackbar && props.snackbar.color) && props.snackbar.color.startsWith('red')">mdi-alert-circle-outline</v-icon>
        <v-icon small :color="(props.snackbar && props.snackbar.color)" v-else-if="(props.snackbar && props.snackbar.color) && props.snackbar.color.startsWith('orange')">mdi-alert-outline</v-icon>
        <v-icon small :color="(props.snackbar && props.snackbar.color)" v-else-if="(props.snackbar && props.snackbar.color) && props.snackbar.color.startsWith('green')">mdi-check-circle-outline</v-icon>
        <v-icon small :color="(props.snackbar && props.snackbar.color)" v-else-if="(props.snackbar && props.snackbar.color) && props.snackbar.color.startsWith('blue')">mdi-information-outline</v-icon>
        {{props.snackbar && props.snackbar.message}}
      </template>
      <template slot="close">{{ $t('views.app.notification.close') }}</template>
    </v-snackbar-queue>

  </v-app>
</template>

<script>
import LanguageChooser from './components/LanguageChooser.vue'

export default {
  name: "app",
  components: { LanguageChooser },
  data: () => ({
      doShowNavigationDrawer: true,
      group: null,
      profiles: []
  }),
  methods: {
    getNavigationItems() {
      let navItems = [
        { icon: "mdi-account-circle", title: this.$t("views.app.navigation.account"), route: "/account", authenticationRequired: true },
        //{ icon: "mdi-view-dashboard", title: this.$t("views.app.navigation.overview"), route: "/overview", authenticationRequired: true }
        { icon: "mdi-message-text", title: this.$t("views.app.navigation.messages"), route: '/messages', authenticationRequired: true },
        { icon: "mdi-frequently-asked-questions", title: this.$t("views.app.navigation.faq"), route: "/faq", authenticationRequired: false },
        { icon: "mdi-information", title: this.$t("views.app.navigation.about"), route: "/about", authenticationRequired: false }
      ];

      return navItems.filter((val) => {
        if (val.authenticationRequired) {
          return this.isLoggedInMSAL();
        }
        return true;
      });
    },
    isLoggedInMSAL() {
      return this.$msal.getAllAccounts().length !== 0;
    },
    logoutMSAL() {
      this.$msal.logoutRedirect();
    },
    isSpecialRoute() {
      return this.$route.path.match('/$') || this.$route.path.startsWith('/login') || this.$route.path.startsWith('/error');
    },
    toggleShowNavigationDrawer() {
      this.doShowNavigationDrawer = !this.doShowNavigationDrawer;
    }
  },
  watch: {
    group() {
      this.drawer = false;
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title = this.$t("views.app.title") + " | " + to.meta.title || "Some Default Title";
      }
    },
  },
}
</script>

<style lang="scss">
@import '../node_modules/typeface-roboto/index.css';
</style>
